var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-breadcrumbs",
    {
      attrs: { color: "primary", "active-color": "primary" },
      scopedSlots: _vm._u([
        {
          key: "separator",
          fn: function(props) {
            return _c("q-icon", {
              attrs: {
                name: "keyboard_arrow_right",
                size: "16px",
                color: "info"
              }
            })
          }
        }
      ])
    },
    [
      _c("q-breadcrumbs-el", {
        staticClass: "uppercase q-caption",
        attrs: { label: "", icon: "home", to: _vm.homeUrl }
      }),
      _vm._l(_vm.$breadcrumbs, function(crumb, index) {
        return crumb.meta && crumb.meta.title
          ? _c("q-breadcrumbs-el", {
              key: index,
              staticClass: "uppercase q-caption",
              attrs: { label: crumb.meta.title, to: crumb.path }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }